/* tslint:disable */
/* eslint-disable */
/**
 * referral-network
 * referral-network
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListDirectoryContactsResponse } from './ListDirectoryContactsResponse';
import {
    ListDirectoryContactsResponseFromJSON,
    ListDirectoryContactsResponseFromJSONTyped,
    ListDirectoryContactsResponseToJSON,
    ListDirectoryContactsResponseToJSONTyped,
} from './ListDirectoryContactsResponse';

/**
 * 
 * @export
 * @interface ListDirectoryContacts200Response
 */
export interface ListDirectoryContacts200Response {
    /**
     * 
     */
    data?: ListDirectoryContactsResponse;
}

/**
 * Check if a given object implements the ListDirectoryContacts200Response interface.
 */
export function instanceOfListDirectoryContacts200Response(value: object): value is ListDirectoryContacts200Response {
    return true;
}

export function ListDirectoryContacts200ResponseFromJSON(json: any): ListDirectoryContacts200Response {
    return ListDirectoryContacts200ResponseFromJSONTyped(json, false);
}

export function ListDirectoryContacts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDirectoryContacts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ListDirectoryContactsResponseFromJSON(json['data']),
    };
}

export function ListDirectoryContacts200ResponseToJSON(json: any): ListDirectoryContacts200Response {
    return ListDirectoryContacts200ResponseToJSONTyped(json, false);
}

export function ListDirectoryContacts200ResponseToJSONTyped(value?: ListDirectoryContacts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ListDirectoryContactsResponseToJSON(value['data']),
    };
}

